/**
 * PasswordStrength — Visual password strength meter.
 */

import { validatePassword, getStrengthLabel, getStrengthColor } from '../validators';

export interface PasswordStrengthMeter {
  container: HTMLElement;
  update: (password: string) => void;
}

export function createPasswordStrength(t: (key: string) => string): PasswordStrengthMeter {
  const container = document.createElement('div');

  const barsRow = document.createElement('div');
  barsRow.className = 'auth-pw-strength';
  const bars: HTMLElement[] = [];
  for (let i = 0; i < 5; i++) {
    const bar = document.createElement('div');
    bar.className = 'auth-pw-bar';
    barsRow.appendChild(bar);
    bars.push(bar);
  }

  const label = document.createElement('div');
  label.className = 'auth-pw-label';

  container.append(barsRow, label);

  return {
    container,
    update(password: string) {
      if (!password) {
        bars.forEach(b => (b.style.background = 'rgba(255,255,255,0.08)'));
        label.textContent = '';
        return;
      }

      const { strength } = validatePassword(password);
      const color = getStrengthColor(strength);
      const labelKey = getStrengthLabel(strength);
      const text = t(labelKey);

      bars.forEach((b, i) => {
        b.style.background = i < strength ? color : 'rgba(255,255,255,0.08)';
      });
      label.textContent = text !== labelKey ? text : '';
      label.style.color = color;
    },
  };
}
